import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { CookieService } from '@app/core/cookies';

@Injectable()
export class CheckoutService {
  private elligibleUsers = {
    dev: [9209022],
    production: [3109466, 10401896, 10053689, 8899356, 8478372],
    stage: [3109466, 10401896, 10053689, 8899356, 8478372]
  };

  constructor(private cookieService: CookieService) {}

  canAccessNewCheckout(): boolean {
    const userId = parseInt(this.cookieService.get('vc_uid'), 10);
    const authorizedUser = this.elligibleUsers[environment.envName].indexOf(userId) >= 0;
    const hasFeatureCookie = parseInt(this.cookieService.get('vc_new_checkout'), 10) > 0;
    return environment.feature.checkout_revamp && (authorizedUser || hasFeatureCookie);
  }

  getCartUrl() {
    return environment.checkoutBaseUrl + 'cart/';
  }

  getCheckoutUrl() {
    return environment.checkoutBaseUrl + 'checkout/';
  }
}
